<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { Router, Route, Link } from "svelte-navigator";
import AllProducts from "./AllProducts.svelte";
    import Categories from "./Categories.svelte";
    import New from "./New.svelte";

    const dispatch = createEventDispatcher();

    function addTitle() {
        dispatch("addTitle", { text: "Products" });
    }

    onMount(() => {
        addTitle();
    });
</script>

<main>
    <Router primary={false}>
        <div class="mainContainer">
            <!-- products menu -->
            <div class="productsMenu ">
                <Link to="">
                    <div class="pnav">
                        <i class="tags icon" />All
                    </div>
                </Link>

                <Link to="new">
                    <div class="pnav">
                        <i class="plus icon" />New
                    </div>
                </Link>
                <Link to="categories">
                    <div class="pnav">
                        <i class="filter icon" />Categories
                    </div>
                </Link>
                <Link to="tags">
                    <div class="pnav">
                        <i class="tag icon" />Tags
                    </div>
                </Link>
            </div>

            <!-- products menu -->

            <div class="producsContainer">
                <Route path="/">
                    <AllProducts />
                </Route>
                <Route path="categories">
                    <Categories />
                </Route>
                <Route path="new">
                    <New />
                </Route>
            </div>
        </div>
    </Router>
</main>

<style>
    .productsMenu {
        padding: 1em;
        border-bottom: 1px solid rgba(128, 128, 128, 0.075);
    }

    .pnav {
        display: inline;
        /* padding-left: 10px; */
        padding-right: 10px;
    }
</style>
